import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  useLocation,
} from "react-router-dom";

import "./App.css";

/* Layout components */
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieConsent from "./components/CookieConsent";

/* Pages – Public */
import HomePage from "./pages/HomePage";
import ContactPage from "./pages/ContactPage";
import PoliciesPage from "./pages/PoliciesPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfUsePage from "./pages/TermsOfUsePage";
import CookiePolicyPage from "./pages/CookiePolicyPage";
import ConsentPolicyPage from "./pages/ConsentPolicyPage";
import SecurityPolicyPage from "./pages/SecurityPolicyPage";
import CommunityPoliciesPage from "./pages/CommunityPoliciesPage";
import AccountSupportPage from "./pages/AccountSupportPage";
import Dashboard from "./pages/Dashboard";
import AIGeneratePage from "./pages/AIGeneratePage";

/* Pages – Auth */
import Register from "./pages/Register";
import Login from "./pages/Login";
import VerifyOtp from "./pages/VerifyOtp";

/* Transitions */
// import PageTransition from "./components/PageTransition";

/* Analytics */
import { logPageView, initGA } from "./utils/analytics";
import CreateDraftPage from "./pages/CreateDraftPage";
import PublishPreviewPage from "./pages/PublishPreviewPage";
import AutoFixPage from "./pages/AutoFixPage";
import FinalPreviewPage from "./pages/FinalPreviewPage";
import MyPostsPage from "./pages/MyPostsPage";
import AdminLogin from "./pages/admin/AdminLogin";
import ApprovalDashboard from "./pages/admin/ApprovalDashboard";

/* ----------------------------------
   Analytics Tracker
----------------------------------- */
function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    logPageView(location.pathname + location.search);
  }, [location]);

  return null;
}

/* ----------------------------------
   Layouts
----------------------------------- */
function PublicLayout() {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
}

function AuthLayout() {
  return (
    // <PageTransition>
      <Outlet />
    // </PageTransition>
  );
}

/* ----------------------------------
   App
----------------------------------- */
export default function App() {
  const [showConsent, setShowConsent] = useState(false);
  const [otpEmail, setOtpEmail] = useState("");

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setShowConsent(true);
    } else if (consent === "accepted") {
      initGA();
    }
  }, []);

  const handleAcceptConsent = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setShowConsent(false);
    initGA();
  };

  const handleDeclineConsent = () => {
    localStorage.setItem("cookie-consent", "declined");
    setShowConsent(false);
  };

  return (
    <Router>
      <AnalyticsTracker />

      <Routes>
        {/* ================= PUBLIC + PRODUCT HOME ================= */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/policies" element={<PoliciesPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsOfUsePage />} />
          <Route path="/cookies" element={<CookiePolicyPage />} />
          <Route path="/consent" element={<ConsentPolicyPage />} />
          <Route path="/security" element={<SecurityPolicyPage />} />
          <Route path="/create" element={<CreateDraftPage />} />
          <Route path="/Home" element={<HomePage />} />
          <Route path="/AdminLogin" element={<AdminLogin onSuccess={() => (window.location.href = "/Approvaldashboard")} />} />
          <Route path="/Approvaldashboard" element={<ApprovalDashboard />} />


          <Route
            path="/community-policies"
            element={<CommunityPoliciesPage />}
          />
          <Route path="/account-support" element={<AccountSupportPage />} />
        </Route>

        {/* ================= AUTH PAGES (NO HEADER/FOOTER) ================= */}
        <Route element={<AuthLayout />}>
          <Route
            path="/register"
            element={
              <Register
                onOtp={(email) => {
                  setOtpEmail(email);
                  window.location.href = "/verify-otp";
                }}
              />
            }
          />

          <Route
            path="/verify-otp"
            element={
              <VerifyOtp
                email={otpEmail}
                onSuccess={() => (window.location.href = "/login")}
              />
            }
          />

          <Route
            path="/login"
            element={<Login onSuccess={() => (window.location.href = "/Home")} />}
          />
        </Route>
           {/* ================= DASHBOARD ================= */}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/ai-generate" element={<AIGeneratePage />} />
          <Route path="/publish-preview" element={<PublishPreviewPage />} />
          <Route path="/auto-fix" element={<AutoFixPage />} />
          <Route path="/final-preview" element={<FinalPreviewPage />} />
          <Route path="/my-posts" element={<MyPostsPage />} />

      </Routes>

      {showConsent && (
        <CookieConsent
          onAccept={handleAcceptConsent}
          onDecline={handleDeclineConsent}
        />
      )}
    </Router>
  );
}
